import { render, staticRenderFns } from "./ViewSundryItemInvoiceListPopUp.vue?vue&type=template&id=82b81fde&scoped=true&"
import script from "./ViewSundryItemInvoiceListPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewSundryItemInvoiceListPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b81fde",
  null
  
)

export default component.exports